import { useReportBespoke } from "@iliotech/data-wire";
import { TemplateType } from "@iliotech/data-wire/src/stores/ReportBespoke/ReportBespokeStore";
import { useNotification } from "src/main";

const FULL_SCREEN_ONLY_COMPONENTS = ["PositionsWidget", "TransactionsWidget"];
export const useDragHandlers = () => {
  const store = useReportBespoke();
  const { error } = useNotification();
  const handleDragOver = ({ over }: any) => {
    const pageId = over?.id.split("-")[0];
    const rowIndex = over?.id.split("-")[1];
    const colIndex = over?.id.split("-")[2];

    // Reset opacity for all cells
    document.querySelectorAll("[data-cell-id]").forEach((cell) => {
      if (cell.className.includes("populated")) return;
      (cell as HTMLElement).style.opacity = "0.7";
    });

    // Set opacity for hovered cell
    if (over) {
      const cellElement = document.querySelector(
        `[data-cell-id="${pageId}-${rowIndex}-${colIndex}"]`
      );
      if (cellElement) {
        (cellElement as HTMLElement).style.opacity = "1";
      }
    }
  };

  const handleDragEnd = ({ over, active }: any) => {
    const id = active.id;
    const pageId = over?.id.split("-")[0];
    const rowIndex = over?.id.split("-")[1];
    const colIndex = over?.id.split("-")[2];
    const isFullScreen =
      store.pages[pageId!].template === TemplateType.FULL_SCREEN;
    // Reset opacity for all cells after drag ends
    document.querySelectorAll("[data-cell-id]").forEach((cell) => {
      if (cell.className.includes("populated")) return;
      (cell as HTMLElement).style.opacity = "0.7";
    });

    // Set opacity and background for the target cell
    if (over) {
      const cellElement = document.querySelector(
        `[data-cell-id="${pageId}-${rowIndex}-${colIndex}"]`
      );
      if (cellElement) {
        (cellElement as HTMLElement).style.opacity = "1";
        (cellElement as HTMLElement).style.backgroundColor = "transparent";
        (cellElement as HTMLElement).classList.add("populated");
      }
    }

    if (FULL_SCREEN_ONLY_COMPONENTS.includes(id) && !isFullScreen) {
      error({
        title: "Error",
        description: "This component is only supported in full screen mode",
      });
      return;
    }
    store.updateCellComponentId(pageId!, `${rowIndex}-${colIndex}`, id);
  };

  return { handleDragOver, handleDragEnd };
};
